import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import Layout from '../components/layout/Layout';
import { CheckCircle2, AlertCircle, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function SubscribeConfirmPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState('loading'); // loading | confirmed | already | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('No confirmation token in URL.');
      return;
    }
    axios
      .get(`${API_URL}/api/subscribers/confirm`, { params: { token } })
      .then((res) => {
        if (res.data.status === 'confirmed') {
          setStatus('confirmed');
        } else if (res.data.status === 'already_confirmed') {
          setStatus('already');
        }
        setMessage(res.data.message || '');
      })
      .catch((e) => {
        setStatus('error');
        setMessage(e.response?.data?.detail || 'This link is invalid or has expired.');
      });
  }, [token]);

  return (
    <Layout title="Confirm Subscription">
      <section className="section-padding bg-[#FAFAFA]" data-testid="subscribe-confirm-page">
        <div className="container-custom max-w-xl">
          <div className="bg-white border border-[#E2E8F0] rounded-2xl p-10 text-center">
            {status === 'loading' && (
              <>
                <Loader2 size={42} className="text-[#1D4ED8] mx-auto mb-4 animate-spin" />
                <h1 className="text-2xl font-bold text-[#0A0F1C] mb-2">Confirming...</h1>
                <p className="text-sm text-[#475569]">Hang tight, we are activating your subscription.</p>
              </>
            )}
            {(status === 'confirmed' || status === 'already') && (
              <div data-testid="confirm-success">
                <div className="w-16 h-16 rounded-full bg-green-50 flex items-center justify-center mx-auto mb-4">
                  <CheckCircle2 size={32} className="text-green-600" />
                </div>
                <h1 className="text-2xl font-bold text-[#0A0F1C] mb-2">You are confirmed</h1>
                <p className="text-sm text-[#475569] mb-6">
                  {message || 'Your subscription is active. Watch your inbox for resources and direct support from DCA Enterprises.'}
                </p>
                <Link
                  to="/"
                  className="inline-block bg-[#F97316] hover:bg-[#EA580C] text-white font-bold py-3 px-6 rounded-lg transition-colors"
                  data-testid="confirm-home-btn"
                >
                  Back to Homepage
                </Link>
              </div>
            )}
            {status === 'error' && (
              <div data-testid="confirm-error">
                <AlertCircle size={42} className="text-[#EF4444] mx-auto mb-4" />
                <h1 className="text-2xl font-bold text-[#0A0F1C] mb-2">Confirmation Failed</h1>
                <p className="text-sm text-[#475569] mb-6">{message}</p>
                <Link
                  to="/contact"
                  className="inline-block bg-[#1D4ED8] hover:bg-[#1E40AF] text-white font-bold py-3 px-6 rounded-lg transition-colors"
                >
                  Contact Us
                </Link>
              </div>
            )}
          </div>
        </div>
      </section>
    </Layout>
  );
}
